import { render, staticRenderFns } from "./StudyNewPageScreeningHeader.vue?vue&type=template&id=5ef04460&scoped=true"
import script from "./StudyNewPageScreeningHeader.vue?vue&type=script&lang=js"
export * from "./StudyNewPageScreeningHeader.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageScreeningHeader.vue?vue&type=style&index=0&id=5ef04460&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef04460",
  null
  
)

export default component.exports